var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isExternalLink)?_c('a',{attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" "+_vm._s(_vm.name)+" ")]):(_vm.link && !_vm.isExternalLink)?_c('router-link',{attrs:{"to":_vm.link,"rel":"noopener noreferrer"}},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }